import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import { RouteConfig } from '@/hooks/useGameConfig';
import { useGoodsStore } from '@/store/modules/goodsStore';
import { useCommonStatus } from '@/store/modules/commonStaus';
import { useVoucherStore } from '@/store/modules/voucher';
import { CommonConstants } from '@/common/constants';
// const isProd = process.env.BASE_ENV === 'production'
const router = createRouter({
  history: CommonConstants.IS_CN ? createWebHashHistory(process.env.VUE_APP_BASE_ROUTE) : createWebHistory(process.env.VUE_APP_BASE_ROUTE),
  routes: [{
    path: '/',
    name: 'Home',
    component: CommonConstants.IS_CN ? function () {
      return import('@/views/home/index.vue');
    } : function () {
      return import('@/views/home/newHome.vue');
    }
  }, {
    path: '/',
    component: function () {
      return import('@/layouts/baseLayout.vue');
    },
    children: [{
      path: ':alias',
      name: 'Shop',
      component: function () {
        return import('@/views/mall/index.vue');
      }
    }]
  }, {
    path: '/subAuth',
    name: 'SubAuth',
    component: function () {
      return import('@/views/mall/subProcess/index.vue');
    }
  }, {
    path: '/authFinish',
    name: 'AuthFinish',
    component: function () {
      return import('@/views/mall/subProcess/finish.vue');
    }
  }, {
    path: '/wechatPay',
    name: 'WechatPay',
    component: function () {
      return import('@/views/mall/payGoods/pcQrCode.vue');
    }
  }, {
    path: '/404',
    // 使用通配符匹配所有路由
    name: '404',
    component: function () {
      return import('@/views/404.vue');
    }
  }]
});
router.beforeEach(function (to, from, next) {
  const store = useGoodsStore();
  const storeSet = useCommonStatus();
  const storeVoucher = useVoucherStore();
  store.payVisible = false; // 重置弹窗状态
  storeSet.voucherActivityVisible = false;
  storeSet.limitRebateVisible = false;
  storeSet.freeGiftSuccessVisible = false;
  storeSet.wechatPayVisible = false;
  storeSet.paySuccessVisible = false;
  storeSet.activityCenterVisible = false;
  storeVoucher.voucherCenterVisible = false;
  if (to.name === 'Shop' && !RouteConfig.includes(to.path)) {
    //   访问404
    next({
      name: '404'
    });
  }
  next();
});
export default router;